"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StudentLocationsIndexController = /** @class */ (function () {
    function StudentLocationsIndexController(UsersModel, UserService, FlashService) {
        var _this = this;
        this.UsersModel = UsersModel;
        this.UserService = UserService;
        this.FlashService = FlashService;
        this.student = UserService.getCurrentUser();
        this.pickupLocations = [];
        this.center = { lat: 0, lng: 0, zoom: 0 };
        UsersModel.getPickupLocations(this.student.id).then(function (response) {
            if (response.pickuplocations.length > 0) {
                _this.pickupLocations = response.pickuplocations.filter(function (location) {
                    return location;
                });
                _this.pickupLocation = _this.pickupLocations[0];
                _this.center = {
                    lat: _this.pickupLocations[0].address.lat,
                    lng: _this.pickupLocations[0].address.lng,
                    zoom: 2,
                };
            }
        });
    }
    StudentLocationsIndexController.prototype.removePickupLocation = function (id) {
        var _this = this;
        var data = {
            user_id: this.UserService.getCurrentUser().id,
            location_id: id,
        };
        this.UsersModel.unattachStudentPickupLocation(data.user_id, data.location_id).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.pickupLocations = response.pickuplocations.filter(function (location) {
                return location;
            });
            _this.pickupLocation = _this.pickupLocations[0];
        });
    };
    return StudentLocationsIndexController;
}());
StudentLocationsIndexController.$inject = [
    "UsersModel",
    "UserService",
    "FlashService",
];
exports.default = StudentLocationsIndexController;
